import { createContext, useContext } from 'react';

import type { IUserContext } from '../../interfaces/user';

const contextDefaultValues: IUserContext = {
  userInfo: null,
  loading: false,
  fetchError: false,
  selectedBrokerId: null,
  fetchUserInfo: async () => {},
  setSelectedBrokerId: () => {}
};

export const UserContext = createContext<IUserContext>(contextDefaultValues);

export const useUser = () => {
  const context = useContext(UserContext);
  const brokers = context.userInfo?.brokers ?? [];
  const isValidSelection = brokers.some((broker) => broker.brokerId === context.selectedBrokerId);
  const brokerId = (isValidSelection ? context.selectedBrokerId : brokers[0]?.brokerId) ?? null;
  return { ...context, brokers, brokerId };
};
